import {LoanInvoice} from "@/models/LoanPayment/LoanInvoice";
import {LoanTransactions} from "@/models/LoanPayment/LoanTransactions";
import {LoanTransaction} from "@/models/LoanPayment/LoanTransaction";

export class LoanProject {

  /**
   * @param {number} id
   * @param {number} loanType
   * @param {number} totalCost
   * @param {Profile} profile
   * @param {number} financedAmount
   * @param {number} insurance
   * @param {number} monthlyPayment
   * @param {number} adminCommission
   * @param {number} financedInterest
   * @param {string|null} completeEvidenceDate
   * @param {string|null} fundDate
   * @param installationDate
   * @param supplierFundingFeePercentage
   * @param {number} deposit
   * @param {number} openingCommission
   */
  constructor(
    id,
    loanType,
    totalCost,
    profile,
    financedAmount,
    insurance,
    monthlyPayment,
    adminCommission,
    financedInterest,
    completeEvidenceDate,
    fundDate,
    installationDate,
    supplierFundingFeePercentage,
    deposit,
    openingCommission,
    applicantFee1,
    applicantFee2,
    creditDisposalAmount,
  ) {
    this.id = id;
    this.loanType = loanType;
    this.profile = profile;
    this.totalCost = totalCost;
    this.financedAmount = financedAmount;
    this.insurance = insurance;
    this.adminCommission = adminCommission;
    this.financedInterest = financedInterest;
    this.contracts = [];
    this.clientInvoice = [];
    this.supplierInvoice = [];
    this.penalties = new LoanTransactions()
    this.bonus = new LoanTransactions()
    this.installationDate = installationDate;
    this.monthlyPayment = monthlyPayment;
    this.fundingCommissionFee = this.isApplicantLoan() ? 0 : supplierFundingFeePercentage;
    this.completeEvidenceDate = completeEvidenceDate;
    this.fundDate = fundDate;
    this.deposit = deposit;
    this.openingCommission = openingCommission;
    this.applicantFee1 = applicantFee1;
    this.applicantFee2 = applicantFee2;
    this.creditDisposalAmount = creditDisposalAmount;
  }

  isApplicantLoan() {
    return this.loanType === 4;
  }

  get contractUnVerified() {
    return this.contracts.filter((contract) => contract.status === 'generated')
  }

  get dispersionAmount() {
    if (this.isApplicantLoan()) {
      return this.financedAmount - this.insurance - this.adminCommission - this.financedInterest;
    }

    return this.totalCost - this.deposit;
  }

  /**
   * @param {number} amount
   * @returns {string}
   */
  calculatePercentage(amount) {
    return ((amount / this.dispersionAmount) * 100).toFixed(2)
  }

  addClientInvoice(
    id,
    trxType,
    profileId,
    profileName,
    concept,
    amount,
    pdfFile,
    xmlFile,
    trxConfirmationDate
  ) {
    this.clientInvoice.push(
      new LoanInvoice(
        id,
        trxType,
        profileId,
        profileName,
        concept,
        amount,
        pdfFile,
        xmlFile,
        trxConfirmationDate
      )
    )
  }

  addSupplierInvoice(
    id,
    trxType,
    profileId,
    profileName,
    concept,
    amount,
    pdfFile,
    xmlFile,
    trxConfirmationDate
  ) {
    this.supplierInvoice.push(
      new LoanInvoice(
        id,
        trxType,
        profileId,
        profileName,
        concept,
        amount,
        pdfFile,
        xmlFile,
        trxConfirmationDate
      )
    )
  }

  addPenalty(
    id,
    profileId,
    trxType,
    amount,
    concept,
    status,
    createdAt,
    trxConfirmationDate
  ) {
    this.penalties.add(
      new LoanTransaction(
        id,
        profileId,
        trxType,
        amount,
        concept,
        status,
        createdAt,
        trxConfirmationDate
      )
    )
  }

  addBonus(
    id,
    profileId,
    trxType,
    amount,
    concept,
    status,
    createdAt,
    trxConfirmationDate
  ) {
    this.bonus.add(
      new LoanTransaction(
        id,
        profileId,
        trxType,
        amount,
        concept,
        status,
        createdAt,
        trxConfirmationDate
      )
    )
  }

  addContract(contract) {
    this.contracts.push(contract)
  }
}
